import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

import askLogin from '../../../assets/images/backgrounds/ask-login.svg';

const BLUE = '#2c96d7';

export const useStyles = makeStyles(({
  breakpoints,
  fontWeights,
  palette,
  borderRadiuses,
}: Theme) => ({
  propsPaperStyles: {
    '&&': {
      paddingTop: 143,
      paddingBottom: '2rem',
      borderRadius: borderRadiuses.md,
      background: `linear-gradient(${BLUE} 0, ${BLUE} 143px, ${palette.common.white} 143px)`,
      '@media (orientation: landscape)': {
        paddingTop: 80,
        backgroundImage: `linear-gradient(${BLUE} 0, ${BLUE} 80px, ${palette.common.white} 80px)`,
      },
      [breakpoints.up('md')]: {
        paddingTop: 230,
        paddingBottom: '2.5rem',
        backgroundImage: `linear-gradient(${BLUE} 0, ${BLUE} 230px, ${palette.common.white} 230px)`,
      },
      [breakpoints.between('md', 813)]: {
        '@media (orientation: landscape)': {
          paddingTop: 80,
          backgroundImage: `linear-gradient(${BLUE} 0, ${BLUE} 80px, ${palette.common.white} 80px)`,
        },
      },
      '&::after': {
        content: '""',
        display: 'block',
        position: 'absolute',
        top: 0,
        left: 0,
        width: 'calc(100% - 34px)',
        height: 143,
        backgroundColor: 'transparent',
        backgroundImage: `url(${askLogin})`,
        backgroundRepeat: 'no-repeat',
        backgroundPositionX: 24,
        backgroundPositionY: 28,
        backgroundSize: 185,
        '@media (orientation: landscape)': {
          height: 80,
          backgroundSize: 83,
        },
        [breakpoints.up('md')]: {
          width: 'calc(100% - 64px)',
          height: 230,
          backgroundPositionX: 64,
          backgroundPositionY: 52,
          backgroundSize: 'unset',
        },
        [breakpoints.between('md', 813)]: {
          '@media (orientation: landscape)': {
            height: 80,
            backgroundSize: 83,
            backgroundPositionY: 28,
          },
        },
      },
    },
  },
  propsContentStyles: {
    padding: '0 1rem',
    [breakpoints.up('md')]: {
      padding: '0 3rem',
    },
  },
  title: {
    margin: '2rem 0 2rem',
    fontSize: '1.25rem',
    lineHeight: 1.35,
    fontWeight: fontWeights.medium,
    [breakpoints.up('md')]: {
      marginTop: '2.5rem',
      fontSize: '1.75rem',
    },
  },
  description: {
    margin: 0,
  },
  actions: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.75rem',
    marginTop: '2rem',
    [breakpoints.up('md')]: {
      flexDirection: 'row',
    },
  },
  login: {
    '&&': {
      paddingLeft: '2rem',
      paddingRight: '2rem',
    },
  },
}));
